import { get } from 'lodash-es';

export const logoId = (expose: any) => get(expose, 'logoId');

export const logoUrl = (expose: any, imageResizeUrl: any) =>
  logoId(expose) ? `${imageResizeUrl}${logoId(expose)}` : null;
